export default __webpack_public_path__ + "static/media/optimize.11eb3fd4.svg";